import React, { useContext, useEffect } from 'react'
import { MapContext } from '@urbica/react-map-gl'
import mapboxgl from 'mapbox-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

export default function Geocoder({ position, accessToken }) {
    const map = useContext(MapContext)

    useEffect(() => {
        const control = new MapboxGeocoder({
            accessToken,
            countries: 'us',
            filter: function(item) {
                // returns true if item contains California region
                return item.context.some(i => {
                    // ID is in the form {index}.{id} per https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
                    // This example searches for the `region` named `California`.
                    return i.id.split('.').shift() === 'region' && i.text === 'California'
                })
            },
            mapboxgl
        })

        map?.addControl(control, position)

        window.geocoder = control

        const searchBar = control.container.querySelector('input[type="text"]')
        searchBar.setAttribute('aria-label', 'Geographic search bar. Searches locations within California.')

        return () => {
            map?.removeControl(control)
        }
    }, [map, position])

    return null
}
